export const MIN_SELECTED_ROWS = 2;
export const MAX_SELECTED_ROWS = 5;
